import { useState } from 'react'

import { ConfirmationDialog } from '@/components/common/data-display/ConfirmationDialog'
import { Button } from '@/components/ui/button'
import { Can } from '@/features/sessao/providers/auth-context'
import { useAuthStore } from '@/features/sessao/store/useAuthStore'
import { CallTechUserReport } from '@/services/backend/config/entities'

import { useGetCallDetails } from '../../hooks/use-call-details'
import { useGetCallProducts } from '../../hooks/use-call-products'
import { ChamadoTecnicoService } from '../../services/chamado-tecnico.service'

interface Props {
  callId: number
  techUserId: string
  onSuccess: (data: CallTechUserReport) => void
}

export default function Component({ callId, techUserId, onSuccess }: Props) {
  const [isOpen, setIsOpen] = useState(false)
  const { user } = useAuthStore()
  const { invalidateCallDetails } = useGetCallDetails(callId)
  const { invalidateCallProducts } = useGetCallProducts(callId)

  if (!user) return null
  if (user.id !== techUserId) return null

  const createHandler = async () => {
    try {
      const res = await ChamadoTecnicoService.create({
        callId,
        techUserId: user.id,
      })
      onSuccess(res)
      invalidateCallDetails()
      invalidateCallProducts()
    } catch {
      // Error toast is already shown by the API connector interceptor
    }
  }

  return (
    <Can asDefault I="create" a="CallReport" passThrough>
      {(allowed) => (
        <>
          <Button disabled={!allowed} onClick={() => setIsOpen(true)}>
            Iniciar atendimento
          </Button>

          <ConfirmationDialog
            isOpen={isOpen}
            onClose={() => setIsOpen(false)}
            onConfirm={createHandler}
          >
            Confirma o início do atendimento?
          </ConfirmationDialog>
        </>
      )}
    </Can>
  )
}
